export default "__VITE_PUBLIC_ASSET__40b56398__"